const routerArr = [
    {
        path: '/order/index/:uuid',
        name: 'orderIndex',
        meta: { title:'确认订单',login:true },
        component: () => import(/* webpackChunkName: 'order' */ './page/index.vue'),
    },
    {
        path: '/order/detail/:orderNo',
        name: 'orderDetail',
        meta: { title:'订单详情',login:true },
        component: () => import(/* webpackChunkName: 'order' */ './page/detail.vue'),
    },
    {
        path: '/order/express/:orderNo',
        name: 'orderExpress',
        meta: { title:'物流详情',login:true },
        component: () => import(/* webpackChunkName: 'order' */ './page/express.vue'),
    },
    {
      path: '/payComplete',
      name: 'payComplete',
      meta: { title:'支付完成',login:false },
      component: () => import(/* webpackChunkName: 'order' */ './page/payComplete.vue'),
    }
  ]
  export default routerArr 